import "./styles.css";
import CountUp from "react-countup";
function Facts() {
  return (
    <section id="facts" class="facts px-5">
      <div class="container px-5" data-aos="fade-up">
        {/* <div class="section-title">
          <h2>Facts</h2>
          <p>
            Magnam dolores commodi suscipit. Necessitatibus eius consequatur ex
            aliquid fuga eum quidem. Sit sint consectetur velit. Quisquam quos
            quisquam cupiditate. Et nemo qui impedit suscipit alias ea. Quia
            fugiat sit in iste officiis commodi quidem hic quas.
          </p>
        </div> */}
        <div class="row">
          <div class="col-lg-3 col-md-6">
            <div class="count-boxx">
              <i class="bi bi-emoji-smile"></i>
              <span>
                <CountUp start={0} end={10} duration={1.75}></CountUp>
              </span>
              <p>Happy Clients</p>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 mt-5 mt-md-0">
            <div class="count-boxx">
              <i class="bi bi-journal-richtext"></i>
              <span>
                <CountUp start={0} end={10} duration={1.75}></CountUp>
              </span>
              <p>Projects</p>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 mt-5 mt-lg-0">
            <div class="count-boxx">
              <i class="bi bi-headset"></i>
              <span>
                <CountUp start={0} end={2000} duration={1.75}></CountUp>
              </span>
              <p>Hours Of Support</p>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 mt-5 mt-lg-0">
            <div class="count-boxx">
              <i class="bi bi-award"></i>
              <CountUp start={0} end={15} duration={1.75}></CountUp>
              <p>Awards</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Facts;
